module.exports = __webpack_public_path__ + "static/media/img22.67301d75.jpg";